import { createUrl } from '_clean-code/utils/urlHelper';
import apiClient from '../../api/index';
import {
  IMultipleStopsService,
  IStopUpdateParams
} from './contracts/multipleStops.service';
import { Logger } from '_clean-code/utils/logger';

const MultipleStopsService: IMultipleStopsService = {
  updateClassificationForMultipleStops: async (
    params: IStopUpdateParams
  ): Promise<any> => {
    try {
      await apiClient.request(
        'PUT',
        createUrl('/v3/stops/classifications').toStringUrl(),
        params
      );
    } catch (error) {
      Logger.error(
        'MultipleStopsService::updateClassificationForMultipleStops',
        error
      );
      throw (error as any).response.data;
    }
  }
};

export default MultipleStopsService;
